import { render, staticRenderFns } from "./in-app-announcement-accept-end-user-agreements.vue?vue&type=template&id=1a566d4e&scoped=true&"
import script from "./in-app-announcement-accept-end-user-agreements.vue?vue&type=script&lang=js&"
export * from "./in-app-announcement-accept-end-user-agreements.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a566d4e",
  null
  
)

export default component.exports